import { useEffect, useState } from 'react';
import { initializePaddle, type Paddle } from '@paddle/paddle-js';
import { readPaddleClientConfig } from './paddleEnv';

export function usePaddle(): Paddle | undefined {
  const [paddle, setPaddle] = useState<Paddle | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    const config = readPaddleClientConfig();
    if (!config) return;
    const { token, environment } = config;
    void initializePaddle({ token, environment }).then((instance) => {
      if (!cancelled && instance) setPaddle(instance);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return paddle;
}
